const ONBOARDING_PATH = 'pages.members.pages.Onboarding';
export const PAGES_PATH_TRANSLATION_KEY = `${ONBOARDING_PATH}.pages`;
export const STEPS_PATH_TRANSLATION_KEY = `${ONBOARDING_PATH}.steps`;
export const COMPONENTS_PATH_TRANSLATION_KEY = `${ONBOARDING_PATH}.components`;
export const COMPONENTS_SHARED_PATH_TRANSLATION_KEY = `${ONBOARDING_PATH}.components.shared`;
